export const ROOMS_LAST_VISITED_UI = 'rooms_last_visited_ui';
export const MEETING_DOCUMENT_IS_UNREAD = 'meeting_document_is_unread';
export const CORPORATE_DOCUMENT_UNREAD = 'corporate_document_unread';
export const PRIVATE_DOCUMENT_UNREAD = 'private_document_unread';
export const CORPORATE_DOCUMENT_VIEWED = 'corporate_document_viewed';
export const PRIVATE_DOCUMENT_VIEWED = 'private_document_viewed';
